
import noUiSlider from 'nouislider'

document.addEventListener("DOMContentLoaded", () => {
	window.initNoUiSlider();
    window.initNoUiSliderPrice();
});

window.initNoUiSlider = () => {

    let rangeSliders = document.querySelectorAll('.range:not(.range--price) .range__slider')
    rangeSliders.forEach((rangeSlider) => {
        let sliderMin = Number(rangeSlider.getAttribute("data-min"))
        let sliderMax = Number(rangeSlider.getAttribute("data-max"))
        let sliderStart = Number(rangeSlider.getAttribute("data-start"))
        let sliderStop = Number(rangeSlider.getAttribute("data-stop"))
        let sliderStep = Number(rangeSlider.getAttribute("data-step"))
        let sliderMargin = Number(rangeSlider.getAttribute("data-margin"))

        noUiSlider.create(rangeSlider, {
            start: [sliderStart, sliderStop],
            step: sliderStep,
            connect: true,
            margin: sliderMargin,
            range: {
                'min': [sliderMin],
                'max': [sliderMax]
            },
            format:{
                to: (v) => v | 0,
                from: (v) => v | 0
            }
        });

        // let snapValues = [
        //     rangeSlider.closest('.range').querySelector('.range__input-min .range__input-count'),
        //     rangeSlider.closest('.range').querySelector('.range__input-max .range__input-count'),
        // ];

        let rangeInput = [
            rangeSlider.closest('.range').querySelector('.range__input-min input'),
            rangeSlider.closest('.range').querySelector('.range__input-max input')
        ]

        // обновление значений
        rangeSlider.noUiSlider.on('update', function (values, handle) {
            // snapValues[handle].innerHTML = values[handle].toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ")
            if(rangeInput[handle]) {
                rangeInput[handle].value = Math.round(values[handle])
            }
        });

        rangeInput.forEach((input, index) => {
            input.addEventListener("change", () => {
                rangeSlider.noUiSlider.setHandle(index, input.value)
            })
        })

        //Сброс значений до начальных
        if(rangeSlider.closest('.filter__cont').querySelector('.range-clear')) {
            let clearButton = rangeSlider.closest('.filter__cont').querySelector('.range-clear')
            clearButton.addEventListener('click', function()  {
                rangeSlider.noUiSlider.reset()
            })
        }

    })

}


window.initNoUiSliderPrice = () => {

    let rangeSliders = document.querySelectorAll('.range--price .range__slider')
    rangeSliders.forEach((rangeSlider) => {
        let sliderMin = Number(rangeSlider.getAttribute("data-min"))
        let sliderMax = Number(rangeSlider.getAttribute("data-max"))
        let sliderStart = Number(rangeSlider.getAttribute("data-start"))
        let sliderStop = Number(rangeSlider.getAttribute("data-stop"))
        let sliderStep = Number(rangeSlider.getAttribute("data-step"))
        let sliderMargin = Number(rangeSlider.getAttribute("data-margin"))

        noUiSlider.create(rangeSlider, {
            start: [sliderStart, sliderStop],
            step: sliderStep,
            connect: true,
            margin: sliderMargin,
            range: {
                'min': [sliderMin],
                'max': [sliderMax]
            },
            pips: {
                mode: 'steps',
            },
            format:{
                to: (v) => v | 0,
                from: (v) => v | 0
            }
        });

        // let snapValues = [
        //     rangeSlider.closest('.range').querySelector('.range__input-min .range__input-count'),
        //     rangeSlider.closest('.range').querySelector('.range__input-max .range__input-count'),
        // ];

        let rangeInput = [
            rangeSlider.closest('.range').querySelector('.range__input-min input'),
            rangeSlider.closest('.range').querySelector('.range__input-max input')
        ]

        // обновление значений
        rangeSlider.noUiSlider.on('update', function (values, handle) {
            // snapValues[handle].innerHTML = values[handle].toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ")
            if(rangeInput[handle]) {
                rangeInput[handle].value = Math.round(values[handle])
            }
        });

        rangeInput.forEach((input, index) => {
            input.addEventListener("change", () => {
                rangeSlider.noUiSlider.setHandle(index, input.value)
            })
        })

        //Сброс значений до начальных
        if(rangeSlider.closest('.filter__cont').querySelector('.range-clear')) {
            let clearButton = rangeSlider.closest('.filter__cont').querySelector('.range-clear')
            clearButton.addEventListener('click', function()  {
                rangeSlider.noUiSlider.reset()
            })
        }

        pips
        let pips = rangeSlider.querySelectorAll('.noUi-value');
    
        function clickOnPip() {
            let value = Number(this.getAttribute('data-value'));
            rangeSlider.noUiSlider.set(value);
        }
    
        for (var i = 0; i < pips.length; i++) {
    
            pips[i].addEventListener('click', clickOnPip);
        }

        let activePips = [null, null];

        rangeSlider.noUiSlider.on('update', function (values, handle) {
            // Remove the active class from the current pip
            if (activePips[handle]) {
                activePips[handle].classList.remove('active-pip');
            }

            // Match the formatting for the pip
            var dataValue = Math.round(values[handle]);

            // Find the pip matching the value
            activePips[handle] = rangeSlider.querySelector('.noUi-value[data-value="' + dataValue + '"]');

            // Add the active class
            if (activePips[handle]) {
                activePips[handle].classList.add('active-pip');
            }
        });

    })

}